const mod = require('../bahabot.module.js')

/**
 * @typedef {Object} CommandGroupAssignment
 * @property {string=} commandId
 * @property {string=} commandGroupId
 * @property {angular.IPromise=} $promise
 * @property {boolean=} $resolved
 */

/**
 * @param {angular.resource.IResourceService} $resource
 * @returns {angular.resource.IResourceClass<CommandGroupAssignment>}
 */
function bahabotCommandGroupAssignmentFactory($resource) {
    /** @type {angular.resource.IResourceClass} */
    const CommandGroupAssignments = $resource('/api/protected/command-group-assignments/:commandId', {
        'commandId': '@commandId'
    }, {
        // Usage: Service.assign({}, { commandId: '...', commandGroupId: '...' })
        assign: { method: 'POST' },
        
        // Usage: Service.unassign({ commandId: '...' })
        unassign: { method: 'DELETE' }
    });

    return CommandGroupAssignments;
}

mod.factory('CommandGroupAssignmentService', ["$resource", bahabotCommandGroupAssignmentFactory]);